import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class ThresholdService {

   constructor(private http: HttpClient) { }
  
  saveThreshold(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.THRESHOLD + '/' + id, payload)
        .pipe(catchError(errorHandl));
    } else {
      return this.http.post(urls.API_URL + urls.THRESHOLD, payload)
        .pipe(catchError(errorHandl));
    }
  }

  getThreshold(id:any, queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(`${urls.API_URL}${urls.THRESHOLD}/company/${id}`, { params })
      .pipe(catchError(errorHandl));
  }

  getThresholdById(id: any) {
    return this.http.get(urls.API_URL + urls.THRESHOLD + '/' + id)
      .pipe(catchError(errorHandl));
  }
}
